// Notification API service
import { getAuthToken } from '../utils/token';

const API_BASE = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getAuthToken()}`
});

export async function fetchNotifications({ page = 1, limit = 20 } = {}) {
  const res = await fetch(`${API_BASE}/api/notifications?page=${page}&limit=${limit}`, {
    headers: authHeaders()
  });
  return res.json();
}

export async function markNotificationRead(id) {
  const res = await fetch(`${API_BASE}/api/notifications/${id}/read`, {
    method: 'PUT',
    headers: authHeaders()
  });
  return res.json();
}

export async function markAllNotificationsRead() {
  const res = await fetch(`${API_BASE}/api/notifications/read-all`, {
    method: 'PUT',
    headers: authHeaders()
  });
  return res.json();
}

export async function deleteNotification(id) {
  const res = await fetch(`${API_BASE}/api/notifications/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  return res.json();
}

export async function deleteAllNotifications() {
  const res = await fetch(`${API_BASE}/api/notifications/delete-all`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  return res.json();
}
